import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export function AdminLoginPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const encoded = searchParams.get("payload");
      if (!encoded) {
        navigate("/login", { replace: true });
        return;
      }

      const decoded = JSON.parse(atob(encoded));

      if (!decoded.token || !decoded.user) {
        navigate("/login", { replace: true });
        return;
      }

      const jwt = jwtDecode(decoded.token);
      if (jwt.exp < Date.now() / 1000) {
        navigate("/login", { replace: true });
        return;
      }

      localStorage.setItem("user", JSON.stringify(decoded));
      window.dispatchEvent(
        new CustomEvent("auth-change", { detail: { type: "login" } })
      );

      const hasBusiness = decoded.user.businesses?.length > 0;
      navigate(hasBusiness ? "/business/dashboard" : "/parcels", {
        replace: true,
      });
    } catch {
      navigate("/login", { replace: true });
    }
  }, [searchParams, navigate]);

  return null;
}
